import { SWITCH_LANGUAGE } from "./actionType";

const switchLanguage = language => ({
  type: SWITCH_LANGUAGE,
  language
});

export { switchLanguage };



// WEBPACK FOOTER //
// ./src/actions/language.js